import { render, staticRenderFns } from "./EditarListaDistribucionModal.vue?vue&type=template&id=94a1401c&"
import script from "./EditarListaDistribucionModal.vue?vue&type=script&lang=ts&"
export * from "./EditarListaDistribucionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports